import {IncludeExclude, PageName, PageState, ProductsAndCampaigns, ResponseStatus, SortState, TrafficSourceResponseDto, User, UserListResponseDto, UserState } from "./types";
import dayjs from "./dayjs";

const singletonState : PageState = {
    page: null, 
    dateStart: dayjs.utc(),
    dateEnd: dayjs.utc(),
    publishers: [],
    placements: [],
    placementsIncludeExclude: IncludeExclude.Include,
    trafficTypes: null,
    trafficTypesIncludeExclude: IncludeExclude.Include,
    countries : null,
    countriesIncludeExclude: IncludeExclude.Include,
    groupBy: null,
    productIds: null,
    productsIncludeExclude: IncludeExclude.Include,
    campaigns: null,
    campaignsIncludeExclude: IncludeExclude.Include,
    queryFlags: null,
    cLinks: null,
    cLinksIncludeExclude: IncludeExclude.Include,
    viewAs: null,
    pivotBy: null,
    dateMode: "days",
};

let userState : UserState = {
  accountCreated: null,
  accountRefreshed: null,
  accountUpdated: null,
  actualUser: null,
  clinks: null,
  email: null,
  filterFields: null,
  groupByFields: null,
  name: null,
  permissions: null,
  picture: null,
  userId: null,
  userIdReference: null
}

const productsAndCampaignsForProductsPage : ProductsAndCampaigns = {
  dto: null
};
const productsAndCampaignsForPerformancePage : ProductsAndCampaigns = {
  dto: null
};
const sortState : SortState = {
  columnIdSorted: "",
  sort: 0
}
let assignableUsersState:User[] = [];
let userListResponseDto:UserListResponseDto = null;
let mostFrequentTagsState:string[] = [];
let trafficSourcesDtoState:TrafficSourceResponseDto = {
  status : ResponseStatus.OK, 
  error : null,
  publishersArray : []
};

let overallSearchFuntion: Function = null;
let productsSearchFuntion: Function = null;
let connexityPrSearchFuntion: Function = null;

const StateHelper = {
  getPageState: function (): PageState {
    //The idea of the page parameter is to hold possible differences of different states
    //in different variables like it initially was done.
    return singletonState;
  },

  getUserState: function(): UserState {
    return userState;
  },
  setUserState: function(newUserState: UserState) {
    userState = newUserState;
  },

  getSortState: function(): SortState {
    return sortState;
  },

  setSearchFuntion: function (page: string, funtionX: Function): void {
    if (page === PageName.overall) {
      overallSearchFuntion = funtionX;
    } else if (page === PageName.products) {
      productsSearchFuntion = funtionX;
    } else if (page === PageName.performanceReports) {
      connexityPrSearchFuntion = funtionX;
    }
  },

  getSearchFuntion: function (page: string): Function {
    let searchFunction: Function = null;
    if (page === PageName.overall) {
      searchFunction = overallSearchFuntion;
    } else if (page === PageName.products) {
      searchFunction = productsSearchFuntion;
    } else if (page === PageName.performanceReports) {
      searchFunction = connexityPrSearchFuntion;
    }
    return searchFunction;
  },

  getProductsAndCampaignsState: function (page: string): ProductsAndCampaigns|null {
    if (page === PageName.products) {
      return productsAndCampaignsForProductsPage;
    } else if (page === PageName.performanceReports) {
      return productsAndCampaignsForPerformancePage;
    }
    return null;
  },

  getUserListResponseDto: function(): UserListResponseDto {
    return userListResponseDto;
  },
  setUserListResponseDto: function(newUserListResponseDto:UserListResponseDto): void {
    userListResponseDto = newUserListResponseDto;
  },

  getAssignableUsersState: function(): User[] {
    return assignableUsersState;
  },
  setAssignableUsersState: function(newAssignableUsers:User[]): void {
    assignableUsersState = newAssignableUsers;
  },

  getMostFrequentTagsState: function(): string[] {
    return mostFrequentTagsState;
  },
  setMostFrequentTagsState: function(newMostFrequentTags:string[]): void {
    mostFrequentTagsState = newMostFrequentTags;
  },

  getTrafficSourcesDtoState: function(): TrafficSourceResponseDto {
    return trafficSourcesDtoState;
  },
  setTrafficSourcesDtoState: function(newTrafficSourcesDtoState:TrafficSourceResponseDto): void {
    trafficSourcesDtoState = newTrafficSourcesDtoState;
  }
};

export default StateHelper;